import CommonIFrame from '../atoms/CommonIFrame';

const TradeTermsSimulator = () => {
    return (
        <CommonIFrame
            src="https://id-preview--78dd4926-c3fa-4c74-ad40-0aa59f38603e.lovable.app/"
            title="Trade Terms Simulator"
        />
    );
};

export default TradeTermsSimulator;
